/**
 * App bootstrap loading preferences and mounting the UI.
 */
import Bunnix from "@bunnix/core";
import App from "./app.mjs";
import { initStore } from "./store/store.mjs";
import { loadPreferences, loadNews } from "./store/persistence.mjs";

const app = document.getElementById('app');
Promise.all([loadPreferences(), loadNews()]).then(([prefs, news]) => {
  initStore(prefs, news);
  Bunnix.render(App(), app);
});

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
    });
  });
}
